import Vue, { PropOptions } from 'vue';
import * as PClass from '@/class';

export default Vue.extend({
  name: 'MixinsViews',
  components: { },
  props: {
  },
  data() {
    return {
      mode: PClass.CONST.MODE.NORMAL,
      antiLoad: 0,
    };
  },
  computed: {
    MODE_NEW(): string { return PClass.CONST.MODE.NEW; },
    MODE_EDIT(): string { return PClass.CONST.MODE.EDIT; },
    MODE_NORMAL(): string { return PClass.CONST.MODE.NORMAL; },
    MODE_SELECT(): string { return PClass.CONST.MODE.SELECT; },
  },
  mounted() {
  },
  methods: {
    mixChangeModeNew() {
      this.mode = PClass.CONST.MODE.NEW;
    },
    mixChangeModeEdit() {
      this.mode = PClass.CONST.MODE.EDIT;
    },
    mixChangeModeNORMAL() {
      this.mode = PClass.CONST.MODE.NORMAL;
    },
    mixChangeModeSELECT() {
      this.mode = PClass.CONST.MODE.SELECT;
    },
    mixChangeMode(nextMode: string) {
      this.mode = nextMode;
    },
    mixGetMode() {
      return this.mode;
    },
    async wait(second: number) {
      return new Promise((resolve) => setTimeout(() => resolve(true), 1000 * second));
    },
    async fncAntiLoading() {
      this.antiLoad++;
      await (this.wait(3))
      if (this.antiLoad > 2) {
        (this.$refs.infiniteLoading as any).stateChanger.complete();
      }
      this.antiLoad = 0;
    },
  },
});
